// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-chat-section {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--welcome-bg);
  box-shadow: var(--welcome-shadow);
  transition: transform 1s;
  transform-origin: 100% 100%;
  display: none;
  border-radius: 4px 4px 0px 0px;
}
.welcome-chat-section.minimize {
  animation: bounce-in 0.5s ease forwards;
  display: flex;
}
.welcome-chat-section.minimizeQuick {
  transform-origin: bottom right;
  animation: quick 0.3s ease forwards;
  display: flex;
}
.welcome-chat-section.minimizeSmooth {
  transform-origin: bottom right;
  animation: quick 0.8s ease forwards;
  display: flex;
}
.welcome-chat-section .welcome-header {
  position: relative;
}
.welcome-chat-section .welcome-header.variation-1 .welcome-header-bg {
  padding: 32px 16px 42px 16px;
}
.welcome-chat-section .welcome-header.variation-1 .welcome-header-bg .logo-img {
  display: none;
}
.welcome-chat-section .welcome-header.variation-1 .bg-logo {
  display: flex;
}
.welcome-chat-section .welcome-header.variation-2 .welcome-header-bg {
  padding: 32px 16px 32px 16px;
}
.welcome-chat-section .welcome-header.variation-2 .welcome-header-bg .logo-img {
  display: none;
}
.welcome-chat-section .welcome-header.variation-2 .bg-logo {
  position: absolute;
  top: 0;
  left: 0;
  border: 3px solid var(--sdk-global-white);
  box-shadow: none;
  display: flex;
}
.welcome-chat-section .welcome-header .welcome-header-bg {
  background: var(--welcome-header-bg) no-repeat;
  background-size: 100% 100%;
  border-radius: 4px 4px 0px 0px;
  padding: 32px 16px;
}
.welcome-chat-section .welcome-header .welcome-header-bg .logo-img {
  margin-bottom: 18px;
  width: 56px;
  height: 56px;
  box-shadow: 0px 10px 15px -3px rgba(16, 24, 40, 0.1), 0px 4px 6px -4px rgba(16, 24, 40, 0.1);
  border-radius: 100%;
}
.welcome-chat-section .welcome-header .welcome-header-bg .logo-img figure {
  width: 100%;
  height: 100%;
}
.welcome-chat-section .welcome-header .welcome-header-bg .logo-img figure img {
  height: 100%;
  width: 100%;
  border-radius: 100%;
}
.welcome-chat-section .welcome-header .welcome-header-bg h1 {
  font-weight: 600;
  font-size: 36px;
  line-height: 44px;
  color: var(--welcome-header-text-color);
  margin-bottom: 6px;
  opacity: 0.6;
}
.welcome-chat-section .welcome-header .welcome-header-bg h2 {
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: var(--welcome-header-text-color);
  margin-bottom: 6px;
}
.welcome-chat-section .welcome-header .welcome-header-bg p {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--welcome-header-text-color);
}
.welcome-chat-section .welcome-header .bg-logo {
  width: 56px;
  height: 56px;
  background: var(--sdk-global-white-bg);
  box-shadow: 0px 10px 15px -3px rgba(16, 24, 40, 0.1), 0px 4px 6px -4px rgba(16, 24, 40, 0.1);
  border-radius: 100%;
  display: none;
  align-items: center;
  justify-content: center;
  margin: -30px 0 10px 16px;
  display: none;
}
.welcome-chat-section .welcome-header .bg-logo figure {
  width: 100%;
  height: 100%;
}
.welcome-chat-section .welcome-header .bg-logo figure img {
  height: 100%;
  width: 100%;
  border-radius: 100%;
}
.welcome-chat-section .welcome-interactions {
  flex: 1 1 auto;
  overflow: auto;
  background: var(--welcome-footer-bg);
}
.welcome-chat-section.hide {
  display: none;
}

.start-conversations-wrapper {
  padding: 16px;
  display: inline-block;
  width: 100%;
}
.start-conversations-wrapper .start-conv-sec {
  background: var(--welcome-start-conv-bg);
  border: 1px solid var(--welcome-start-conv-border);
  border-radius: 4px;
  padding: 15px;
}
.start-conversations-wrapper .start-conv-sec .conv-starter-box {
  display: flex;
  align-items: center;
}
.start-conversations-wrapper .start-conv-sec .conv-starter-box .bot_icon, .start-conversations-wrapper .start-conv-sec .conv-starter-box .bot_icon_image {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  margin-right: 8px;
  background: var(--avatar-bg);
  border-radius: 24px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.start-conversations-wrapper .start-conv-sec .conv-starter-box .bot_icon svg path, .start-conversations-wrapper .start-conv-sec .conv-starter-box .bot_icon_image svg path {
  fill: var(--avatar-icon-color);
}
.start-conversations-wrapper .start-conv-sec .conv-starter-box .bot_icon span svg path, .start-conversations-wrapper .start-conv-sec .conv-starter-box .bot_icon_image span svg path {
  fill: none;
  stroke: var(--avatar-icon-color);
}
.start-conversations-wrapper .start-conv-sec .conv-starter-box .bot_icon img, .start-conversations-wrapper .start-conv-sec .conv-starter-box .bot_icon_image img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
}
.start-conversations-wrapper .start-conv-sec .conv-starter-box .bot_icon_image {
  background-color: transparent;
  padding: 0px;
}
.start-conversations-wrapper .start-conv-sec .conv-starter-box .bot_icon_image img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
}
.start-conversations-wrapper .start-conv-sec .conv-starter-box .conv-starter-content-info {
  width: 100%;
}
.start-conversations-wrapper .start-conv-sec .conv-starter-box .conv-starter-content-info .conv-starter-title {
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: var(--welcome-start-conv-bot-title);
}
.start-conversations-wrapper .start-conv-sec .conv-starter-box .conv-starter-content-info .conv-starter-desc {
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: var(--welcome-start-conv-bot-desc);
  margin-top: 3px;
}
.start-conversations-wrapper .start-conv-sec .quick-start-buttons-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 16px 0;
}
.start-conversations-wrapper .start-conv-sec .quick-start-buttons-container.stacked-buttons .quick-start-btn {
  width: 100%;
}
.start-conversations-wrapper .start-conv-sec .quick-start-buttons-container .quick-start-btn {
  background: var(--welcome-start-conv-quick-btn-bg);
  border: 1px solid var(--welcome-start-conv-quick-btn-border);
  border-radius: 4px;
  height: 40px;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: var(--welcome-start-conv-quick-btn-text);
  cursor: pointer;
  position: relative;
}
.start-conversations-wrapper .start-conv-sec .quick-start-buttons-container .quick-start-btn.hovered-default-bg {
  background: var(--sdk-global-theme-color);
  color: var(--sdk-global-white);
}
.start-conversations-wrapper .start-conv-sec .quick-start-buttons-container .quick-start-btn:hover {
  background: var(--sdk-gloabl-secondary-color);
}
.start-conversations-wrapper .start-conv-sec .quick-start-buttons-container .quick-start-btn .new-item {
  position: absolute;
  right: -14px;
  top: -16px;
  width: 30px;
  height: 30px;
  z-index: 1;
}
.start-conversations-wrapper .start-conv-sec .quick-start-buttons-container .quick-start-btn .emoji-symbol {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  font-size: 15px;
  margin-right: 6px;
}
.start-conversations-wrapper .start-conv-sec .start-conv-button {
  margin-top: 16px;
  background: var(--welcome-start-conv-button-bg);
  border-radius: 4px;
  width: 100%;
  display: flex;
  align-items: center;
  text-align: start;
  padding: 10px 16px;
  height: 40px;
  border: 1px solid var(--welcome-start-conv-button-border);
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--welcome-start-conv-button-color);
  cursor: pointer;
  gap: 10px;
}
.start-conversations-wrapper .start-conv-sec .start-conv-button span {
  width: 100%;
}
.start-conversations-wrapper .start-conv-sec .start-conv-button svg {
  flex-shrink: 0;
}
.start-conversations-wrapper .start-conv-sec .start-conv-button svg path {
  stroke: var(--sdk-global-white-bg);
}
.start-conversations-wrapper .start-conv-sec .start-conv-search-block {
  display: flex;
  align-items: center;
  margin-top: 16px;
  width: 100%;
  gap: 10px;
}
.start-conversations-wrapper .start-conv-sec .start-conv-search-block .start-conv-search {
  position: relative;
  width: 100%;
}
.start-conversations-wrapper .start-conv-sec .start-conv-search-block .start-conv-search .search-icon {
  position: absolute;
  left: 10px;
  top: 9px;
  font-size: 16px;
}
.start-conversations-wrapper .start-conv-sec .start-conv-search-block .start-conv-search .search-icon svg path {
  fill: var(--sdk-gloabl-text-color);
}
.start-conversations-wrapper .start-conv-sec .start-conv-search-block .start-conv-search input {
  background: var(--welcome-start-conv-search-bg);
  border: 1px solid var(--sdk-gloabl-border-color);
  border-radius: 4px;
  width: 100%;
  height: 34px;
  padding: 7px 10px 7px 32px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--sdk-gloabl-text-color);
}
.start-conversations-wrapper .start-conv-sec .start-conv-search-block .start-conv-search input::placeholder {
  color: var(--sdk-gloabl-text-color);
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  opacity: 0.5;
}
.start-conversations-wrapper .start-conv-sec .start-conv-search-block .start-conv-search input:focus {
  border: solid 1px var(--sdk-global-theme-color);
}
.start-conversations-wrapper .start-conv-sec .start-conv-search-block .start-conv-search input:active {
  border: solid 1px var(--sdk-global-theme-color);
}
.start-conversations-wrapper .start-conv-sec .start-conv-search-block .start-conv-search input:disabled {
  opacity: 0.4;
  pointer-events: none;
  cursor: not-allowed;
}
.start-conversations-wrapper .start-conv-sec .start-conv-search-block .start-conv-search input.error {
  border: solid 1px #ff001f;
}
.start-conversations-wrapper .start-conv-sec .start-conv-search-block .search-send {
  background: var(--welcome-start-conv-button-bg);
  border-radius: 4px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--welcome-start-conv-button-border);
  font-size: 14px;
  color: var(--welcome-start-conv-button-color);
  cursor: pointer;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
}
.start-conversations-wrapper .start-conv-sec .start-conv-search-block .search-send svg path {
  fill: var(--sdk-global-white-bg);
}

.pramotional-banner-wrapper-container {
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
}
.pramotional-banner-wrapper-container .banner-img {
  display: inline-block;
  width: 100%;
  cursor: pointer;
}
.pramotional-banner-wrapper-container .banner-img img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  max-height: 180px;
  border-radius: 4px;
}

.link-wrapper-content {
  padding: 0 16px 16px 16px;
  display: inline-block;
  width: 100%;
}
.link-wrapper-content .main-heading-wrapper {
  width: 100%;
}
.link-wrapper-content .main-heading-wrapper h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.link-wrapper-content .link-temp-wrapper {
  width: 100%;
  box-shadow: 0px 1px 2px -1px rgba(16, 24, 40, 0.1), 0px 1px 3px 0px rgba(16, 24, 40, 0.1);
  border-radius: 4px;
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--sdk-global-white-bg);
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
}
.link-wrapper-content .link-temp-wrapper.carousel-temp-links {
  display: block;
}
.link-wrapper-content .link-temp-wrapper.carousel-temp-links .main-heading-wrapper {
  margin-bottom: 12px;
}

.link-list-template-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--sdk-global-white-bg);
  cursor: pointer;
}
.link-list-template-wrapper .img-block {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
}
.link-list-template-wrapper .img-block.xs {
  width: 16px;
  height: 16px;
}
.link-list-template-wrapper .img-block.lg {
  width: 60px;
  height: 60px;
}
.link-list-template-wrapper .img-block.xlg {
  width: 80px;
  height: 80px;
}
.link-list-template-wrapper .img-block figure {
  line-height: 0px;
}
.link-list-template-wrapper .img-block img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
.link-list-template-wrapper .img-block img.radius-100 {
  border-radius: 100%;
}
.link-list-template-wrapper .titles-info-block {
  width: 100%;
}
.link-list-template-wrapper .titles-info-block h1 {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 600;
  line-height: normal;
}
.link-list-template-wrapper .titles-info-block p {
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  margin-top: 6px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.link-list-template-wrapper .right-actions-content {
  flex-shrink: 0;
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.link-list-template-wrapper .right-actions-content .arrow-icon {
  font-size: 14px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
}
.link-list-template-wrapper .right-actions-content .arrow-icon svg path {
  stroke: var(--sdk-gloabl-text-color);
}

.carousel-temp-links {
  display: flex;
  align-items: center;
  position: relative;
  gap: 10px;
}
.carousel-temp-links .carousel-left-click {
  position: absolute;
  border-radius: 32px;
  background: var(--sdk-global-white);
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  display: flex;
  width: 32px;
  height: 32px;
  padding: 0px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: 0;
  left: 15px;
  top: auto;
  cursor: pointer;
  flex-shrink: 0;
  z-index: 9;
}
.carousel-temp-links .carousel-left-click svg path {
  stroke: var(--sdk-gloabl-text-color);
}
.carousel-temp-links .carousel-left-click.hide {
  display: none;
}
.carousel-temp-links .carousel-right-click {
  position: absolute;
  border-radius: 32px;
  background: var(--sdk-global-white);
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  display: flex;
  width: 32px;
  height: 32px;
  padding: 0px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: 0;
  left: 15px;
  top: auto;
  cursor: pointer;
  flex-shrink: 0;
  z-index: 9;
}
.carousel-temp-links .carousel-right-click svg path {
  stroke: var(--sdk-gloabl-text-color);
}
.carousel-temp-links .carousel-right-click {
  left: auto;
  right: 15px;
}
.carousel-temp-links .carousel-link-temp-wrapper {
  display: flex;
  overflow: hidden;
  gap: 10px;
}
.carousel-temp-links .carousel-link-temp-wrapper .link-list-template-wrapper {
  width: 90%;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/base/welcomeScreenContainer/welcomeScreenContainer.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,iCAAA;EACA,wBAAA;EACA,2BAAA;EACA,aAAA;EACA,8BAAA;AADJ;AAEI;EACI,uCAAA;EACA,aAAA;AAAR;AAEI;EACI,8BAAA;EACA,mCAAA;EACA,aAAA;AAAR;AAEI;EACI,8BAAA;EACA,mCAAA;EACA,aAAA;AAAR;AAEI;EACI,kBAAA;AAAR;AAEY;EACI,4BAAA;AAAhB;AACgB;EACI,aAAA;AACpB;AAEY;EACI,aAAA;AAAhB;AAIY;EACI,4BAAA;AAFhB;AAGgB;EACI,aAAA;AADpB;AAIY;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,yCAAA;EACA,gBAAA;EACA,aAAA;AAFhB;AAKQ;EACI,8CAAA;EACA,0BAAA;EACA,8BAAA;EACA,kBAAA;AAHZ;AAIY;EACI,mBAAA;EACA,WAAA;EACA,YAAA;EAEA,4FAAA;EACA,mBAAA;AAHhB;AAIgB;EACI,WAAA;EACA,YAAA;AAFpB;AAGoB;EACI,YAAA;EACA,WAAA;EACA,mBAAA;AADxB;AAKY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uCAAA;EACA,kBAAA;EACA,YAAA;AAHhB;AAKY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uCAAA;EACA,kBAAA;AAHhB;AAKY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uCAAA;AAHhB;AAMQ;EACI,WAAA;EACA,YAAA;EACA,sCAAA;EACA,4FAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;AAJZ;AAKY;EACI,WAAA;EACA,YAAA;AAHhB;AAIgB;EACI,YAAA;EACA,WAAA;EACA,mBAAA;AAFpB;AAOI;EACI,cAAA;EACA,cAAA;EACA,oCAAA;AALR;AAQI;EACI,aAAA;AANR;;AAYA;EACI,aAAA;EACA,qBAAA;EACA,WAAA;AATJ;AAUI;EACI,wCAAA;EACA,kDAAA;EACA,kBAAA;EACA,aAAA;AARR;AASQ;EACI,aAAA;EACA,mBAAA;AAPZ;AAQY;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,4BAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AANhB;AAQoB;EACI,8BAAA;AANxB;AAWwB;EACI,UAAA;EACA,gCAAA;AAT5B;AAagB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAXpB;AAcY;EAEI,6BAAA;EACA,YAAA;AAbhB;AAcgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAZpB;AAeY;EACI,WAAA;AAbhB;AAcgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0CAAA;AAZpB;AAcgB;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,eAAA;AAZpB;AAgBQ;EACI,aAAA;EACA,eAAA;EACA,QAAA;EACA,cAAA;AAdZ;AAgBgB;EACI,WAAA;AAdpB;AAiBY;EACI,kDAAA;EACA,4DAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+CAAA;EACA,eAAA;EACA,kBAAA;AAfhB;AAgBgB;EACI,yCAAA;EACA,8BAAA;AAdpB;AAgBgB;EACI,6CAAA;AAdpB;AAgBgB;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAdpB;AAgBgB;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAdpB;AAkBQ;EACI,gBAAA;EACA,+CAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,yDAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,6CAAA;EACA,eAAA;EACA,SAAA;AAhBZ;AAiBY;EACI,WAAA;AAfhB;AAiBY;EACI,cAAA;AAfhB;AAgBgB;EACI,kCAAA;AAdpB;AAkBQ;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;AAhBZ;AAiBY;EACI,kBAAA;EACA,WAAA;AAfhB;AAgBgB;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;AAdpB;AAgBwB;EACI,kCAAA;AAd5B;AAkBgB;EACI,+CAAA;EACA,gDAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mCAAA;AAhBpB;AAiBoB;EACI,mCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AAfxB;AAiBoB;EACI,+CAAA;AAfxB;AAiBoB;EACI,+CAAA;AAfxB;AAiBoB;EACI,YAAA;EACA,oBAAA;EACA,mBAAA;AAfxB;AAiBoB;EACI,yBAAA;AAfxB;AAmBY;EACI,+CAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yDAAA;EACA,eAAA;EACA,6CAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAjBhB;AAmBoB;EACI,gCAAA;AAjBxB;;AA2BA;EACI,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;AAxBJ;AAyBI;EACI,qBAAA;EACA,WAAA;EACA,eAAA;AAvBR;AAwBQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAtBZ;;AA2BA;EACI,yBAAA;EACA,qBAAA;EACA,WAAA;AAxBJ;AAyBI;EACI,WAAA;AAvBR;AAwBQ;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAtBZ;AAyBI;EACI,WAAA;EACA,yFAAA;EACA,kBAAA;EACA,gDAAA;EACA,sCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAvBR;AAwBQ;EACI,cAAA;AAtBZ;AAuBY;EACI,mBAAA;AArBhB;;AA2BA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;EACA,kBAAA;EACA,gDAAA;EACA,sCAAA;EACA,eAAA;AAxBJ;AAyBI;EACI,cAAA;EACA,WAAA;EACA,YAAA;AAvBR;AAwBQ;EACI,WAAA;EACA,YAAA;AAtBZ;AAwBQ;EACI,WAAA;EACA,YAAA;AAtBZ;AAwBQ;EACI,WAAA;EACA,YAAA;AAtBZ;AAwBQ;EACI,gBAAA;AAtBZ;AAwBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AAtBZ;AAuBY;EACI,mBAAA;AArBhB;AAyBI;EACI,WAAA;AAvBR;AA2BQ;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAzBZ;AA+BQ;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;AA7BZ;AAgCI;EACI,cAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AA9BR;AA+BQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;AA7BZ;AA+BgB;EACI,oCAAA;AA7BpB;;AAoCA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AAjCJ;AAmCI;EACI,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,mDAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;AAjCR;AAmCY;EACI,oCAAA;AAjChB;AAoCQ;EACG,aAAA;AAlCX;AAqCI;EACI,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,mDAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;AAnCR;AAqCY;EACI,oCAAA;AAnChB;AAeI;EAsBa,UAAA;EACT,WAAA;AAlCR;AAoCI;EACI,aAAA;EACA,gBAAA;EACA,SAAA;AAlCR;AAmCQ;EACI,UAAA;EACA,cAAA;AAjCZ","sourcesContent":["\n\n.welcome-chat-section {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    background: var(--welcome-bg);\n    box-shadow: var(--welcome-shadow);\n    transition: transform 1s;\n    transform-origin: 100% 100%;\n    display: none;\n    border-radius: 4px 4px 0px 0px;\n    &.minimize{\n        animation: bounce-in 0.5s ease forwards;\n        display: flex;\n    }\n    &.minimizeQuick{   \n        transform-origin: bottom right;            \n        animation: quick 0.3s ease forwards;\n        display: flex;\n    }\n    &.minimizeSmooth{   \n        transform-origin: bottom right;            \n        animation: quick 0.8s ease forwards;\n        display: flex;\n    }\n    .welcome-header {\n        position: relative;\n        &.variation-1 {\n            .welcome-header-bg {\n                padding: 32px 16px 42px 16px;\n                .logo-img {\n                    display: none;\n                }                \n            }\n            .bg-logo{\n                display: flex;\n            }\n        }\n        &.variation-2 {\n            .welcome-header-bg {\n                padding: 32px 16px 32px 16px;\n                .logo-img {\n                    display: none;\n                }\n            }\n            .bg-logo {\n                position: absolute;\n                top: 0;\n                left: 0;\n                border: 3px solid var(--sdk-global-white);\n                box-shadow: none;\n                display: flex;\n            }\n        }\n        .welcome-header-bg {\n            background: var(--welcome-header-bg) no-repeat;\n            background-size: 100% 100%;\n            border-radius: 4px 4px 0px 0px;\n            padding: 32px 16px;\n            .logo-img {\n                margin-bottom: 18px;\n                width: 56px;\n                height: 56px;\n                // background: var(--sdk-global-white-bg);\n                box-shadow: 0px 10px 15px -3px rgba(16, 24, 40, 0.1), 0px 4px 6px -4px rgba(16, 24, 40, 0.1);\n                border-radius: 100%;\n                figure{\n                    width: 100%;\n                    height: 100%;\n                    img{\n                        height: 100%;\n                        width: 100%;\n                        border-radius: 100%;\n                    }\n                }\n            }\n            h1 {\n                font-weight: 600;\n                font-size: 36px;\n                line-height: 44px;\n                color: var(--welcome-header-text-color);\n                margin-bottom: 6px;\n                opacity: 0.6;\n            }\n            h2 {\n                font-weight: 700;\n                font-size: 18px;\n                line-height: 22px;\n                color: var(--welcome-header-text-color);\n                margin-bottom: 6px;\n            }\n            p {\n                font-weight: 400;\n                font-size: 14px;\n                line-height: 17px;\n                color: var(--welcome-header-text-color);\n            }\n        }\n        .bg-logo {\n            width: 56px;\n            height: 56px;\n            background: var(--sdk-global-white-bg);\n            box-shadow: 0px 10px 15px -3px rgba(16, 24, 40, 0.1), 0px 4px 6px -4px rgba(16, 24, 40, 0.1);\n            border-radius: 100%;\n            display: none;\n            align-items: center;\n            justify-content: center;\n            margin: -30px 0 10px 16px;\n            display: none;\n            figure{\n                width: 100%;\n                height: 100%;\n                img{\n                    height: 100%;\n                    width: 100%;\n                    border-radius: 100%;\n                }\n            }\n        }\n    }\n    .welcome-interactions {\n        flex: 1 1 auto;\n        overflow: auto;\n        background: var(--welcome-footer-bg);\n    }\n\n    &.hide {\n        display: none;\n    }\n}\n\n// Conversations Starter Box\n\n.start-conversations-wrapper{\n    padding: 16px;\n    display: inline-block;\n    width: 100%;\n    .start-conv-sec{\n        background: var(--welcome-start-conv-bg);\n        border: 1px solid var(--welcome-start-conv-border);\n        border-radius: 4px;\n        padding: 15px;\n        .conv-starter-box{\n            display: flex;\n            align-items: center;\n            .bot_icon{\n                width: 40px;\n                height: 40px;\n                flex-shrink: 0;\n                margin-right: 8px;\n                background: var(--avatar-bg);\n                border-radius: 24px;\n                padding: 10px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                font-size: 16px;\n                svg {\n                    path {\n                        fill: var(--avatar-icon-color);\n                    }\n                }\n                span {\n                    svg {\n                        path {\n                            fill: none;\n                            stroke: var(--avatar-icon-color);\n                        }\n                    }\n                }\n                img {\n                    width: 100%;\n                    height: 100%;\n                    border-radius: 100%;\n                }\n            }\n            .bot_icon_image {\n                @extend .bot_icon;\n                background-color: transparent;\n                padding: 0px;\n                img {\n                    width: 100%;\n                    height: 100%;\n                    border-radius: 100%;\n                }\n            }\n            .conv-starter-content-info{\n                width: 100%;\n                .conv-starter-title{\n                    font-weight: 600;\n                    font-size: 14px;\n                    line-height: 17px;\n                    color: var(--welcome-start-conv-bot-title);\n                }\n                .conv-starter-desc{\n                    font-weight: 400;\n                    font-size: 12px;\n                    line-height: 18px;\n                    color: var(--welcome-start-conv-bot-desc);\n                    margin-top: 3px;\n                }\n            }\n        }\n        .quick-start-buttons-container{\n            display: flex;\n            flex-wrap: wrap;\n            gap: 8px;\n            margin: 16px 0;\n            &.stacked-buttons{\n                .quick-start-btn{\n                    width: 100%;\n                }\n            }\n            .quick-start-btn{\n                background: var(--welcome-start-conv-quick-btn-bg);\n                border: 1px solid var(--welcome-start-conv-quick-btn-border);\n                border-radius: 4px;\n                height: 40px;\n                padding: 10px 15px;\n                display: flex;\n                align-items: center;\n                font-weight: 500;\n                font-size: 14px;\n                line-height: 20px;\n                color: var(--welcome-start-conv-quick-btn-text); \n                cursor: pointer;\n                position: relative;                \n                &.hovered-default-bg{\n                    background: var(--sdk-global-theme-color);\n                    color: var(--sdk-global-white);\n                }\n                &:hover{\n                    background: var(--sdk-gloabl-secondary-color);\n                }\n                .new-item{\n                    position: absolute;\n                    right: -14px;\n                    top: -16px;\n                    width: 30px;\n                    height: 30px;\n                    z-index: 1;\n                }\n                .emoji-symbol{\n                    width: 20px;\n                    height: 20px;\n                    flex-shrink: 0;\n                    font-size: 15px;\n                    margin-right: 6px;\n                }\n            }\n        }\n        .start-conv-button{\n            margin-top: 16px;\n            background: var(--welcome-start-conv-button-bg);\n            border-radius: 4px;\n            width: 100%;\n            display: flex;\n            align-items: center;\n            text-align: start;\n            padding: 10px 16px;\n            height: 40px;\n            border: 1px solid var(--welcome-start-conv-button-border);\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: var(--welcome-start-conv-button-color);\n            cursor: pointer;\n            gap: 10px;\n            span{\n                width: 100%;\n            }\n            svg{\n                flex-shrink: 0;\n                path{\n                    stroke: var(--sdk-global-white-bg);\n                }\n            }\n        }\n        .start-conv-search-block{\n            display: flex;\n            align-items: center;\n            margin-top: 16px;\n            width: 100%;\n            gap: 10px;\n            .start-conv-search{\n                position: relative;\n                width: 100%;\n                .search-icon{\n                    position: absolute;\n                    left: 10px;\n                    top: 9px;\n                    font-size: 16px;\n                    svg{\n                        path{\n                            fill: var(--sdk-gloabl-text-color);\n                        }\n                    }\n                }\n                input{\n                    background: var(--welcome-start-conv-search-bg);\n                    border: 1px solid var(--sdk-gloabl-border-color);\n                    border-radius: 4px;\n                    width: 100%;\n                    height: 34px;\n                    padding: 7px 10px 7px 32px;\n                    font-weight: 400;\n                    font-size: 14px;\n                    line-height: 20px;\n                    color: var(--sdk-gloabl-text-color);\n                    &::placeholder{\n                        color: var(--sdk-gloabl-text-color);\n                        font-weight: 400;\n                        font-size: 14px;\n                        line-height: 20px;\n                        opacity: 0.5;\n                    }\n                    &:focus{\n                        border: solid 1px var(--sdk-global-theme-color)\n                    }\n                    &:active{\n                        border: solid 1px var(--sdk-global-theme-color);\n                    }\n                    &:disabled{\n                        opacity: 0.4;\n                        pointer-events: none;\n                        cursor: not-allowed;\n                    }\n                    &.error{\n                        border: solid 1px #ff001f;\n                    }\n                }\n            }\n            .search-send{\n                background: var(--welcome-start-conv-button-bg);\n                border-radius: 4px;\n                padding: 8px;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                border: 1px solid var(--welcome-start-conv-button-border);\n                font-size: 14px;\n                color: var(--welcome-start-conv-button-color);\n                cursor: pointer;\n                width: 34px;\n                height: 34px;\n                flex-shrink: 0;\n                svg{\n                    path{\n                        fill: var(--sdk-global-white-bg);\n                    }\n                }\n            }\n        }\n    }\n}\n\n// Pramotional Banners\n\n.pramotional-banner-wrapper-container{\n    padding: 0 16px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 12px;\n    .banner-img{\n        display: inline-block;\n        width: 100%;\n        cursor: pointer;\n        img{\n            width: 100%;\n            height: 100%;\n            object-fit: fill;\n            max-height: 180px;\n            border-radius: 4px;\n        }\n    }\n}\n\n.link-wrapper-content{\n    padding: 0 16px 16px 16px;\n    display: inline-block;\n    width: 100%;\n    .main-heading-wrapper{\n        width: 100%;\n        h1{\n            color: var(--sdk-gloabl-text-color);\n            font-size: 18px;\n            font-weight: 600;\n            line-height: 20px;\n            width: 100%;\n            overflow: hidden;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n        }\n    }\n    .link-temp-wrapper{\n        width: 100%;\n        box-shadow: 0px 1px 2px -1px rgba(16, 24, 40, 0.10), 0px 1px 3px 0px rgba(16, 24, 40, 0.10);\n        border-radius: 4px;\n        border: 1px solid var(--sdk-gloabl-border-color);\n        background: var(--sdk-global-white-bg);\n        display: flex;\n        padding: 16px;\n        flex-direction: column;\n        justify-content: center;\n        align-items: flex-start;\n        gap: 12px;\n        align-self: stretch;\n        &.carousel-temp-links{\n            display: block;\n            .main-heading-wrapper{\n                margin-bottom: 12px;\n            }\n        }\n    }\n}\n\n.link-list-template-wrapper{\n    width: 100%;        \n    display: flex;\n    align-items: center;\n    padding: 16px;\n    gap: 8px;\n    border-radius: 4px;\n    border: 1px solid var(--sdk-gloabl-border-color);\n    background: var(--sdk-global-white-bg);\n    cursor: pointer;\n    .img-block{\n        flex-shrink: 0;\n        width: 48px;\n        height: 48px;\n        &.xs{\n            width: 16px;\n            height: 16px;\n        }\n        &.lg{\n            width: 60px;\n            height: 60px;     \n        }\n        &.xlg{\n            width: 80px;\n            height: 80px;\n        }\n        figure{\n            line-height: 0px;\n        }\n        img{\n            width: 100%;\n            height: 100%;\n            border-radius: 8px;\n            &.radius-100{\n                border-radius: 100%;\n            }\n        }\n    }\n    .titles-info-block{\n        width: 100%;\n        // overflow: hidden;\n        // white-space: nowrap;\n        // text-overflow: ellipsis;\n        h1{\n            color: var(--sdk-gloabl-text-color);\n            font-size: 14px;\n            font-weight: 600;\n            line-height: normal;\n            // overflow: hidden;\n            // white-space: nowrap;\n            // text-overflow: ellipsis;\n            // width: 100%;\n        }\n        p{\n            color: var(--sdk-gloabl-text-color);\n            font-size: 12px;\n            font-weight: 400;\n            line-height: normal;\n            margin-top: 6px;\n            display: -webkit-box;\n            -webkit-box-orient: vertical;\n            -webkit-line-clamp: 2;\n            overflow: hidden;\n        }\n    }\n    .right-actions-content{\n        flex-shrink: 0;\n        gap: 10px;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        .arrow-icon{\n            font-size: 14px;\n            width: 20px;\n            height: 20px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border: 0;\n            background: transparent;\n            padding: 0;\n            cursor: pointer;\n            svg{\n                path{\n                    stroke: var(--sdk-gloabl-text-color);\n                }\n            }\n        }\n    }\n}\n\n.carousel-temp-links{\n    display: flex;\n    align-items: center;\n    position: relative;\n    gap: 10px;\n\n    .carousel-left-click {\n        position: absolute;\n        border-radius: 32px;\n        background: var(--sdk-global-white);\n        box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n        display: flex;\n        width: 32px;\n        height: 32px;\n        padding: 0px;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n        border: 0;\n        left: 15px;\n        top: auto;\n        cursor: pointer;\n        flex-shrink: 0;\n        z-index: 9;\n        svg{\n            path{\n                stroke: var(--sdk-gloabl-text-color);\n            }\n        }\n        &.hide {\n           display: none;\n        }\n    }\n    .carousel-right-click {\n        position: absolute;\n        border-radius: 32px;\n        background: var(--sdk-global-white);\n        box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n        display: flex;\n        width: 32px;\n        height: 32px;\n        padding: 0px;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n        border: 0;\n        left: 15px;\n        top: auto;\n        cursor: pointer;\n        flex-shrink: 0;\n        z-index: 9;\n        svg{\n            path{\n                stroke: var(--sdk-gloabl-text-color);\n            }\n        }        left: auto;\n        right: 15px;\n    }\n    .carousel-link-temp-wrapper{\n        display: flex;\n        overflow: hidden;\n        gap: 10px;\n        .link-list-template-wrapper{\n            width: 90%;\n            flex-shrink: 0;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
